import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountConfig } from '../../../../models/account-config.model';
import { Account } from '../../../../models/ui/account.model';
import { ConfigBase } from '../../../../models/config-base.model';
import { NotificationManager } from '../../../../managers/notification.manager';
import { AccountManager } from '../../../../managers/account.manager';

@Component({
    selector: 'lex-account-config',
    templateUrl: './account-config.component.html',
    styleUrls: ['./account-config.component.scss'],
    standalone: false
})
export class AccountConfigComponent {

	public account: Account;
	public accountConfigs: AccountConfig[] = [];
	public accountConfigBaseList: ConfigBase[] = [];

	constructor(
		private accountManager: AccountManager,
		private notificationManager: NotificationManager,
		@Inject(MAT_DIALOG_DATA) private inputAccount: Account) {
		//Get account to from AccountId in dialog data.
		this.account = this.inputAccount;
		this.accountManager.getAccountConfigs(this.account.accountId)
			.subscribe(data => {
				// data is an array of last subscriptions (next) of each of the observables above in the same order
				this.accountConfigs = data;
				this.accountConfigBaseList = this.accountConfigs.map(ac => this.toConfigBase(ac));
			});
	}

	public saveConfig(config: ConfigBase): void {
		const existingConfig = this.accountConfigs.find(ac => ac.accountConfigTypeId == config.configTypeId);
		existingConfig.value = config.value;
		this.accountManager.updateAccountConfig(existingConfig).subscribe(() => {
			this.notificationManager.displaySnackBarMessage({
				message: 'Account configuration updated successfully.'
			});
		});
	}

	private toConfigBase(config: AccountConfig): ConfigBase {
		return {
			configTypeId: config.accountConfigTypeId,
			value: config.value,
			type: {
				value: config.accountConfigType.id,
				displayName: config.accountConfigType.name,
				dataType: config.accountConfigType.dataType
			}
		};
	}
}
